import { useEffect, Component } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Intro from "./components/Intro";
import Amenities from "./components/Amenities";
import Services from "./components/Services";
import Reviews from "./components/Reviews";
import Gallery from "./components/Gallery";
import Location from "./components/Location";
import Rates from "./components/Rates";
import Booking from "./components/Booking";
import ChatWidget from "./components/ChatWidget";
import Footer, { WhatsAppFloat } from "./components/Footer";
import Admin from "./pages/Admin";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import "@/App.css";

class ErrorBoundary extends Component {
  state = { error: false };
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="grid min-h-screen place-items-center bg-sand p-8 text-center font-sans text-ink">
          <div>
            <p className="font-serif text-3xl italic">Private Oasis Villa</p>
            <p className="mt-3 text-sm text-ink2">Qualcosa è andato storto. Ricarica la pagina.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const Grain = () => (
  <div
    aria-hidden="true"
    className="grain pointer-events-none fixed inset-0 z-30 opacity-[0.05] mix-blend-multiply"
  />
);

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="overflow-x-clip bg-sand font-sans text-ink antialiased">
      <Grain />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Intro />
        <Amenities />
        <Services />
        <Reviews />
        <Gallery />
        <Location />
        <Rates />
        <Booking />
      </main>
      <Footer />
      <WhatsAppFloat />
      <ChatWidget />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Site />} />
          </Routes>
          <Toaster position="bottom-left" richColors closeButton />
        </BrowserRouter>
      </LangProvider>
    </ErrorBoundary>
  );
}

export default App;
